export default {
  set(state, data) {
    state.data = data;
  }
};
